import React from 'react';
import type { GlobalNumberingSettings } from '../../../../../../types/matterNumbering';

interface GlobalSettingsProps {
  settings: GlobalNumberingSettings;
  onChange: (settings: GlobalNumberingSettings) => void;
}

export const GlobalSettings: React.FC<GlobalSettingsProps> = ({
  settings,
  onChange: _onChange
}) => {
  return (
    <div className="p-4">
      <h3 className="text-lg font-medium mb-4">Global Settings</h3>
      <p className="text-gray-600 dark:text-gray-400">
        Sequence padding: {settings.sequencePadding}
      </p>
      <p className="text-sm text-gray-500 mt-2">
        Global settings component - implementation pending
      </p>
    </div>
  );
}; 